import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetTrigger,
} from '@/components/ui/sheet';
import { useClerk, useUser } from '@clerk/clerk-react';
import {
  BarChart,
  Building,
  Calculator,
  FileText,
  LayoutDashboard,
  LogOut,
  Menu,
  Settings,
  Users,
  X,
} from 'lucide-react';
import type React from 'react';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export const Sidebar: React.FC = () => {
  const location = useLocation();
  const { user } = useUser();
  const { signOut } = useClerk();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    signOut();
    setOpen(false);
  };

  const navLinks = [
    {
      to: '/dashboard',
      label: 'Dashboard',
      icon: <LayoutDashboard className="h-6 w-6" />,
    },
    { to: '/assets', label: 'Assets', icon: <Building className="h-6 w-6" /> },
    { to: '/contacts', label: 'Contacts', icon: <Users className="h-6 w-6" /> },
    {
      to: '/quick-reports',
      label: 'Quick Reports',
      icon: <BarChart className="h-6 w-6" />,
    },
    {
      to: '/documents',
      label: 'Documents',
      icon: <FileText className="h-6 w-6" />,
    },
    {
      to: '/kpi-settings',
      label: 'KPI Settings',
      icon: <Calculator className="h-6 w-6" />,
    },
    {
      to: '/settings',
      label: 'Settings',
      icon: <Settings className="h-6 w-6" />,
    },
  ];

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="fixed top-4 left-4 z-40">
          <Menu className="h-6 w-6" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="p-0">
        <div className="flex h-full flex-col">
          <div className="flex items-center justify-between p-4 border-b">
            <div className="flex flex-col">
              <span className="text-lg font-semibold">PropTrack</span>
              <span className="text-sm text-muted-foreground">
                {user?.primaryEmailAddress?.emailAddress}
              </span>
            </div>
            <SheetClose asChild>
              <Button variant="ghost" size="icon">
                <X className="h-5 w-5" />
              </Button>
            </SheetClose>
          </div>

          <nav className="flex-1 p-4 space-y-2">
            {navLinks.map((link) => (
              <SheetClose key={link.to} asChild>
                <Link
                  to={link.to}
                  className={`flex items-center gap-3 rounded-lg px-3 py-3 text-sm transition-all hover:bg-accent ${
                    location.pathname === link.to ||
                    location.pathname.startsWith(`${link.to}/`)
                      ? 'bg-accent'
                      : ''
                  }`}
                >
                  {link.icon}
                  <span>{link.label}</span>
                </Link>
              </SheetClose>
            ))}
          </nav>

          <div className="p-4 border-t">
            <Button
              onClick={handleLogout}
              variant="ghost"
              className="flex w-full items-center justify-start gap-3 rounded-lg px-3 py-3 text-sm transition-all hover:bg-accent"
            >
              <LogOut className="h-6 w-6" />
              <span>Logout</span>
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
